import { SignJWT } from 'jose'


export const generateJWT = async (payload) => {
  try {

    // Prefix + giveawayId = Secret Key per GiveawayId.
    const secretKeyGiveawayId = 'REACT_APP_JWT_SECRET_GIVEAWAY_' + payload.giveawayId.toUpperCase();

    const secret = new TextEncoder().encode(
      process.env[secretKeyGiveawayId],
    )
    
    const jwt = await new SignJWT(payload)
      .setProtectedHeader({ alg: 'HS256', typ: 'JWT' })
      .setExpirationTime('10m')
      .sign(secret)
  
    return jwt;
  } catch (e) {
    // console.log(e);
    return { error: e };
  }
};

export default generateJWT;